import { Observable, switchMap } from 'rxjs';
import { createAuthorizationHeaders, get$, post$ } from 'services/axios';
import {
  NoteCreatePayload,
  NoteCreateResponse,
  NoteListResponse,
  NoteEntityResponse,
} from 'types/dto';

/**
 * Create an observable emitting note creation response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createCreateNote$ = (token$: Observable<string>) => (payload: NoteCreatePayload) =>
  token$.pipe(
    switchMap(token =>
      post$<NoteCreateResponse>(`/v1/notes/bank`, payload, createAuthorizationHeaders(token)),
    ),
  );

/**
 * Create an observable emitting individual notes
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetNote$ = (token$: Observable<string>) => (noteId: string) =>
  token$.pipe(
    switchMap(token =>
      get$<NoteEntityResponse>(`/v1/notes/bank/${noteId}`, createAuthorizationHeaders(token)),
    ),
  );

/**
 * Create an observable emitting notes
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetNoteList$ = (token$: Observable<string>) => (transactionId: string) =>
  token$.pipe(
    switchMap(token =>
      get$<NoteListResponse>(
        `/v1/notes/bank-transactions/${transactionId}`,
        createAuthorizationHeaders(token),
      ),
    ),
  );
